import { Text, Flex } from '@chakra-ui/react';
import { Banner, OutlineCard } from '@morressier/alembic';
import NoReviewsFound from '../ReviewList/EmptyState';
import { useReviewData } from 'src/contexts/ReviewDataProvider';
import InvitationPreviewNew from '../InvitationPreview/InvitationPreview';
import { IEmailLog } from '@publishing-engine/domain/types/email-template';

const Invitation: React.FC<{body : IEmailLog[] | undefined}> = ({ body }) => {
  const { review, availableActions } = useReviewData();
  const {
    caseData: { acceptance }
  } = review;
  const firstEmail = body?.[0];

  if (
    !(
      availableActions.contains('PeerReviewDecision#acceptRequest') ||
      availableActions.contains('PeerReviewDecision#declineRequest')
    )
  ) {
    return (
      <Flex padding={16}>
        <NoReviewsFound />
      </Flex>
    );
  }
  return (
    <Flex width="100%" flexDirection="column">
      {(!acceptance || acceptance === 'decline') && (
        <OutlineCard borderless padding={8} width="100%">
          <Flex flexDirection="column" gap={4}>
            {acceptance === 'decline' ? (
              <Banner
                variant="error"
                heading="You have declined this invitation"
                content="We appreciate your consideration and hope to collaborate on future opportunities. No further action is required on your part for this review process."
              />
            ) : (
              <>
                {firstEmail ? (
                  <InvitationPreviewNew
                    body={firstEmail.body}
                    subject={firstEmail.subject}
                  />
                ) : (
                  <Text>No invitation email found.</Text>
                )}
              </>
            )}
          </Flex>
        </OutlineCard>
      )}
    </Flex>
  );
};

export default Invitation;
